/**
 * Reads typing in the default activator field: updates the activator search, asks for the list
 * when the text is not empty, and reports `text-input`, plus `update-search` for a remote select.
 *
 * @param {{ menuOpen: import("vue").Ref<boolean>, updateActivatorSearch: (value: string) => void,
 *   remoteEnabled: import("vue").Ref<boolean>, emit: (name: string, value: string) => void }} options
 *   `emit` is the component's own.
 * @returns {{ handleTextInput: (hostEvent: CustomEvent) => void }}
 */
export function useSelectActivatorInput({ menuOpen, updateActivatorSearch, remoteEnabled, emit }) {
  // Typing asks for the list the way a click does, so a field reached with Tab opens on the first
  // keystroke. Emptying the field asks for nothing.
  function handleTextInput(hostEvent) {
    const { detail } = hostEvent;

    const [value] = detail;

    updateActivatorSearch(value);

    if (value) {
      menuOpen.value = true;
    }

    emit("text-input", value);

    if (remoteEnabled.value) {
      emit("update-search", value);
    }
  }

  return {
    handleTextInput,
  };
}
